import { IUpdateProjetoInformacoesUseCase } from "../../../presentation/useCases/update/update_projeto_informacoes_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class UpdateProjetoInformacoesUseCase implements IUpdateProjetoInformacoesUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async updateProjetoInformacoes(IdInformacoes: number,        
  IdProjeto: number,   
  DescInformacoes: string | null,
  IdFuncionario: number | null,   
  Data: Date | null): Promise<void> {
    return await this.repository.updateProjetoInformacoes(IdInformacoes, IdProjeto, DescInformacoes, IdFuncionario, Data);
  }
}
